var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useState } from 'react';
///@ts-ignore
import ReactSelect from 'react-select';
import { FormFieldForSelect } from '@styled/Form';
import { useSheetRows } from '../../data/sheetRow/sheetRowActions';
import { useSheetRowsById } from '../../data/sheetRow/sheetRowHooks';
var ClusterParentSelect = function (props) {
    var _a;
    var sheetRows = useSheetRows();
    var sheetRowsById = useSheetRowsById();
    var options = getClusterParentSelectOptions((_a = sheetRows.data) !== null && _a !== void 0 ? _a : [], sheetRowsById, !!props.hasRoot);
    var _b = __read(useState(options), 2), sortedOptions = _b[0], setSortedOptions = _b[1];
    var compareOptionLabelWithValue = function (label, value) {
        if (value === label)
            return 1;
        if (label.endsWith('/' + value))
            return 2;
        if (label.includes('/' + value + '/'))
            return 4;
        if (label.includes('/' + value))
            return 3;
        if (label.includes(' ' + value))
            return 5;
        if (label.includes(value))
            return 6;
        return Infinity;
    };
    var sortOptionsWithValue = function (options, value) {
        var array = __spreadArray([], __read(options), false);
        return array.sort(function (a, b) {
            return compareOptionLabelWithValue(a.label.toLowerCase(), value) -
                compareOptionLabelWithValue(b.label.toLowerCase(), value);
        });
    };
    var onInputChange = function (value, actionMeta) {
        if (actionMeta.action === 'input-change' && value !== '') {
            var sorted = sortOptionsWithValue(options, value.toLowerCase());
            setSortedOptions(sorted);
        }
        else if (actionMeta.action === 'menu-close' || value === '') {
            setSortedOptions(options);
        }
    };
    var location = props.location, selected = props.selected, onChange = props.onChange, _c = props.placeholder, placeholder = _c === void 0 ? 'Select parent' : _c, _d = props.size, size = _d === void 0 ? 'large' : _d;
    var selectedOption = sortedOptions.find(function (o) { return o.value === selected; });
    var customStyles = {
        menuPortal: function (provided, state) { return (__assign(__assign({}, provided), { zIndex: 2000 })); },
        option: function (provided, state) { return (__assign(__assign({}, provided), { fontSize: size === 'large' ? 12 : 11, padding: '5px 10px' })); },
    };
    return (React.createElement(FormFieldForSelect, { "$small": size === 'small' },
        React.createElement(ReactSelect, { blurInputOnSelect: true, disabled: props.disabled, className: "fs-select", classNamePrefix: "fs-select", menuPortalTarget: document.body, styles: customStyles, placeholder: placeholder, options: sortedOptions, isClearable: false, value: selectedOption, onChange: function (opt) { return onChange(Number.parseInt(opt.value)); }, onInputChange: onInputChange })));
};
function getClusterParentSelectOptions(sheetRows, sheetRowsMap, hasRoot) {
    var e_1, _a;
    var getLineageString = function (targetId, lineage) {
        var _a;
        var row = sheetRowsMap[targetId];
        if (row !== undefined) {
            lineage.push(row.name);
            getLineageString((_a = row.parentId) !== null && _a !== void 0 ? _a : 0, lineage);
        }
    };
    var possibleParentOptions = [];
    try {
        for (var sheetRows_1 = __values(sheetRows), sheetRows_1_1 = sheetRows_1.next(); !sheetRows_1_1.done; sheetRows_1_1 = sheetRows_1.next()) {
            var _b = sheetRows_1_1.value, id = _b.id, parentId = _b.parentId, name = _b.name;
            var lineage = [name];
            getLineageString(parentId !== null && parentId !== void 0 ? parentId : 0, lineage);
            possibleParentOptions.push({
                label: lineage.reverse().join('/'),
                value: id,
                disabled: false,
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (sheetRows_1_1 && !sheetRows_1_1.done && (_a = sheetRows_1.return)) _a.call(sheetRows_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (hasRoot) {
        return __spreadArray([{ label: 'Root', value: 0, disabled: false }], __read(possibleParentOptions), false);
    }
    return possibleParentOptions;
}
export default ClusterParentSelect;
